const version='1.10.10'; const hash='cab3a7f'; export {version, hash};
